import { render, staticRenderFns } from "./ErrorHtml.vue?vue&type=template&id=406be74e&"
import script from "./ErrorHtml.vue?vue&type=script&lang=js&"
export * from "./ErrorHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports